const xbt = {
  picking_fee: process.env.VUE_APP_PICKING_FEE,
  checking_fee: process.env.VUE_APP_CHECKING_FEE,
  packing_fee: process.env.VUE_APP_PACKING_FEE,
};

module.exports = xbt;
